import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'

export interface ConfirmOtpForAccountMatchingOutput extends BaseOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  DateTimeNextRequestIsAvailable: string
  MobilePrefix: string | null
  MobilePhone: string | null
  Email: string | null
  LockedTime: number
  Password: string
  PhoneNumber: string
  PhonePrefix: string
  RemainingPasswordAttempts: number
  Tipo: string
  AccountState: number
  UrlRedirect: string
  GuidAccount: string
  UserPnr: string
  InitialLoginClient: string
  InitialLoginRedirect: string
  Name: string
  Surname: string
  ActiveServices: string[]
  LoginSession: string
  ExternalEmail: string
  ExternalPhoneNumber: string
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isConfirmOtpForAccountMatchingOutput = (obj: any): obj is ConfirmOtpForAccountMatchingOutput => {
  const dateTimeNextRequestIsAvailable = 'DateTimeNextRequestIsAvailable'
  const mobilePrefix = 'MobilePrefix'
  const mobilePhone = 'MobilePhone'
  const email = 'Email'

  return (
    isBaseOutput(obj) &&
    has(obj, dateTimeNextRequestIsAvailable) &&
    has(obj, mobilePrefix) &&
    has(obj, mobilePhone) &&
    has(obj, email)
  )
}
